import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { SecondaryButton } from '../Button';
import Infotip from '../Tooltip';
import rawRing from '../../images/raw-ring.png';
import { brandBody } from '../../content/about';

interface Props {
  expanded: boolean;
  onToggle: () => void;
}

const TheBrand = ({ expanded, onToggle }: Props) => {
  const paragraphs = expanded ? brandBody : [brandBody[0]];

  return (
    <Container id="the-brand" sx={{ mt: 4, justifyContent: 'center', display: 'flex' }} maxWidth={false}>
      <Grid container spacing={4} sx={{ maxWidth: { sm: '95%', md: 1000, lg: 1200 }, width: '100%' }} alignItems='center' display='flex' justifyContent='center'>
        <Grid size={{ xs: 12, lg: 7 }} sx={{ order: { xs: 2, lg: 1 }, pr: { lg: 3 } }}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography component="h2" data-testid="about-product-title" gutterBottom fontSize={{ md: '2rem', xl: '3rem' }} sx={{ textAlign: 'center' }} pb={2}>
              iets'ene ke eng
              <Infotip title="Meaning: What is iets'ene?"/>
            </Typography>
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              {paragraphs.map((text, i) => (
                <Typography key={i} variant='body1' fontSize={{ md: '1.4rem', xl: '2rem' }} gutterBottom>
                  {text}
                </Typography>
              ))}
            </Box>
            <SecondaryButton
              sx={{ fontSize: { md: '1rem', xl: '2rem' }, mt: 2 }}
              onClick={onToggle}
            >
              {expanded ? 'Show less' : 'Read more'}
            </SecondaryButton>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, lg: 5 }} sx={{ order: { xs: 1, lg: 2 } }}>
          <Box component="img" src={rawRing} alt='raw-peg-spring' data-testid="about-product-image" sx={{ width: '100%', height: 'auto', borderRadius: '10%' }} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default TheBrand;